export const PV_TAB_LABEL = "Pressure Vessel";
export const PV_TAB_HASH_KEY = "structure-piping-pressure-vessel-tab";
// The tabs inside PV's Estimation - Main Estimation / Main BOM / Attachment.
// The key is the navLabel their NavTabs was given (see EstimationTab), which
// is the hash key it reads its selected tab from.
export const PV_ESTIMATION_SUB_HASH_KEY = "pv-estimation-sub";

/**
 * The /plant/:plantId/estimation deep link shape shared by
 * EmsProjectsTreeView's confirm-and-open flow and PlantModuleNav's "jump
 * straight to the only existing revision" links - kept in one place so both
 * stay in sync. `topTabLabel` picks the equipment tab (Structure/Piping/
 * Pressure Vessel, defaulting to Pressure Vessel); `subTabLabel` (PV only)
 * additionally picks a sub-tab (e.g. "Estimation") via the "pv-modeling"
 * hash key, since Structure/Piping have no equivalent; `estimationSubTabLabel`
 * goes one level deeper still, naming a tab inside PV's Estimation ("Main
 * Estimation", "Main BOM", "Attachment") - what a document filed under a PV
 * revision opens. `wbsType` names which half of the Piping module to open
 * (Spec, Estimation, or both for a legacy "pip" WBS) - see pipingWbsTabs in
 * constants/projectTypes.js.
 */
export const buildEstimationHref = ({
  plantId,
  projectId,
  projectName,
  revision,
  topTabLabel,
  subTabLabel,
  estimationSubTabLabel,
  wbsType,
  newRevision = false,
}) => {
  const resolvedTopTabLabel = topTabLabel || PV_TAB_LABEL;
  const params = new URLSearchParams({
    projectId: projectId ?? "",
    projectName: projectName || "",
    equipmentTab: resolvedTopTabLabel,
  });
  if (revision != null) {
    params.set("revision", revision);
  }
  if (wbsType) {
    params.set("wbsType", wbsType);
  }
  if (newRevision) {
    params.set("newRevision", "1");
  }
  const hash =
    `${PV_TAB_HASH_KEY}=${encodeURIComponent(resolvedTopTabLabel)}` +
    (subTabLabel ? `&pv-modeling=${encodeURIComponent(subTabLabel)}` : "") +
    // Read when the Estimation sub-tab mounts, which is only once the
    // "pv-modeling" hash above has opened it - so this is always set
    // alongside it, never on its own.
    (estimationSubTabLabel
      ? `&${PV_ESTIMATION_SUB_HASH_KEY}=${encodeURIComponent(
          estimationSubTabLabel,
        )}`
      : "");

  return `/plant/${plantId}/estimation?${params.toString()}#${hash}`;
};
